/* eslint-disable */
/**
 *
 * @param {*} fileType - array
 * @returns
 */

import { DownloadOutlined } from '@ant-design/icons';

import { Badge, Card, Space, Tabs, Typography } from 'antd';

import { DownloadViaLink, GetFileLabel } from '../../clientUtils';

const { Text } = Typography;

const iconStyles = { fontSize: '24px' };

export default function FileTabs({ files, fileTypes }) {
  /**
   * key
   * label
   * children
   */
  let fileType = {};
  fileTypes.map((i) => (fileType = { ...fileType, [i]: [] }));
  // let fileType = {
  //     PURCHASE_INVOICE,
  //     ASN_PACKING_LIST,
  //     MRP_TAG,
  //     CARTON_MARKINGS,
  // };
  files?.forEach((file) => fileType[file.file_type]?.push(file));
  const items = [];
  for (const property in fileType) {
    const item = {
      key: property,
      label: (
        <Badge
          count={fileType?.[property].length}
          offset={[12, 8]}
          style={{ backgroundColor: '#F0F0F0', color: 'black' }}>
          <span>{GetFileLabel(property)}</span>
          {'  '}
        </Badge>
      ),
      children: <FileDisplay files={fileType?.[property]} />
    };
    if (fileType?.[property].length) items.push(item);
  }

  return <Tabs items={items} tabBarGutter={50} />;
}

const FileDisplay = ({ files }) => {
  return (
    <Space>
      {files?.map((item) => (
        <Card key={item?.id} className="center h-100px" hoverable style={{ width: 168 }}>
          <Space align="center" direction="vertical">
            <Space align="center" size="large">
              <DownloadOutlined
                className="accent-color"
                onClick={() => DownloadViaLink(item?.s3url, item?.file_name)}
                style={iconStyles}
              />
            </Space>
            <Text ellipsis style={{ maxWidth: 100 }}>
              {item?.file_name}
            </Text>
          </Space>
        </Card>
      ))}
    </Space>
  );
};
